/* tslint:disable */
/* eslint-disable */
/**
 * Xpanse Portal BFF Service API
 * Rest API for Xpanse Portal
 *
 * The version of the OpenAPI document: @project.version@
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuthType } from './auth-type';
import {
    AuthTypeFromJSON,
    AuthTypeFromJSONTyped,
    AuthTypeToJSON,
    AuthTypeToJSONTyped,
} from './auth-type';

/**
 * Authentication discovery result containing configuration details for a specific authentication method
 * @export
 * @interface AuthDiscoveryResult
 */
export interface AuthDiscoveryResult {
    /**
     * Type of authentication method supported for this configuration
     * @type {AuthType}
     * @memberof AuthDiscoveryResult
     */
    authType: AuthType;
    /**
     * AWS Cognito User Pool ID where the user authentication will be handled
     * @type {string}
     * @memberof AuthDiscoveryResult
     */
    cognitoPoolId: string;
    /**
     * AWS Cognito Client ID for the application
     * @type {string}
     * @memberof AuthDiscoveryResult
     */
    cognitoClientId: string;
    /**
     * Identity provider name configured in Cognito (e.g., 'COGNITO' for native Cognito users, 'AzureAD' for SSO)
     * @type {string}
     * @memberof AuthDiscoveryResult
     */
    cognitoIdentityProvider: string;
    /**
     * AWS region where the Cognito User Pool is hosted
     * @type {string}
     * @memberof AuthDiscoveryResult
     */
    cognitoRegion: string;
    /**
     * AWS Cognito domain for hosted UI authentication
     * @type {string}
     * @memberof AuthDiscoveryResult
     */
    cognitoDomain: string;
    /**
     * Human-readable name of the tenant/organization
     * @type {string}
     * @memberof AuthDiscoveryResult
     */
    tenantName: string;
    /**
     * Unique code identifier for the tenant/organization
     * @type {string}
     * @memberof AuthDiscoveryResult
     */
    tenantCode: string;
    /**
     * OAuth2 authority endpoint URL for initiating the authentication flow
     * @type {string}
     * @memberof AuthDiscoveryResult
     */
    authorityEndpoint: string;
}



/**
 * Check if a given object implements the AuthDiscoveryResult interface.
 */
export function instanceOfAuthDiscoveryResult(value: object): value is AuthDiscoveryResult {
    if (!('authType' in value) || value['authType'] === undefined) return false;
    if (!('cognitoPoolId' in value) || value['cognitoPoolId'] === undefined) return false;
    if (!('cognitoClientId' in value) || value['cognitoClientId'] === undefined) return false;
    if (!('cognitoIdentityProvider' in value) || value['cognitoIdentityProvider'] === undefined) return false;
    if (!('cognitoRegion' in value) || value['cognitoRegion'] === undefined) return false;
    if (!('cognitoDomain' in value) || value['cognitoDomain'] === undefined) return false;
    if (!('tenantName' in value) || value['tenantName'] === undefined) return false;
    if (!('tenantCode' in value) || value['tenantCode'] === undefined) return false;
    if (!('authorityEndpoint' in value) || value['authorityEndpoint'] === undefined) return false;
    return true;
}

export function AuthDiscoveryResultFromJSON(json: any): AuthDiscoveryResult {
    return AuthDiscoveryResultFromJSONTyped(json, false);
}

export function AuthDiscoveryResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthDiscoveryResult {
    if (json == null) {
        return json;
    }
    return {
        
        'authType': AuthTypeFromJSON(json['authType']),
        'cognitoPoolId': json['cognitoPoolId'],
        'cognitoClientId': json['cognitoClientId'],
        'cognitoIdentityProvider': json['cognitoIdentityProvider'],
        'cognitoRegion': json['cognitoRegion'],
        'cognitoDomain': json['cognitoDomain'],
        'tenantName': json['tenantName'],
        'tenantCode': json['tenantCode'],
        'authorityEndpoint': json['authorityEndpoint'],
    };
}

export function AuthDiscoveryResultToJSON(json: any): AuthDiscoveryResult {
    return AuthDiscoveryResultToJSONTyped(json, false);
}

export function AuthDiscoveryResultToJSONTyped(value?: AuthDiscoveryResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authType': AuthTypeToJSON(value['authType']),
        'cognitoPoolId': value['cognitoPoolId'],
        'cognitoClientId': value['cognitoClientId'],
        'cognitoIdentityProvider': value['cognitoIdentityProvider'],
        'cognitoRegion': value['cognitoRegion'],
        'cognitoDomain': value['cognitoDomain'],
        'tenantName': value['tenantName'],
        'tenantCode': value['tenantCode'],
        'authorityEndpoint': value['authorityEndpoint'],
    };
}

